import { render, staticRenderFns } from "./ForgotPasswordPage.vue?vue&type=template&id=321adf80&"
import script from "./ForgotPasswordPage.vue?vue&type=script&lang=ts&"
export * from "./ForgotPasswordPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('321adf80')) {
      api.createRecord('321adf80', component.options)
    } else {
      api.reload('321adf80', component.options)
    }
    module.hot.accept("./ForgotPasswordPage.vue?vue&type=template&id=321adf80&", function () {
      api.rerender('321adf80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Auth/ForgotPasswordPage.vue"
export default component.exports